// ChartLine Component - Extracted from map
interface ChartLineProps {
  path: string;
  color: string;
}

export function ChartLine({ path, color }: ChartLineProps) {
  return (
    <path
      d={path}
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  );
}

export default ChartLine;
